const BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL;

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginResponse {
  userId: string;
  username: string;
  email: string;
  clubId: string | null;
  exp: number;
  iss: string;
}

export class AuthProvider {
  async initResetPassword(email: string): Promise<void> {
    const res = await fetch(`${BASE_URL}/v1/users/init-reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
      credentials: "include",
    });

    if (!res.ok) {
      const error = await res.json().catch(() => ({}));
      throw new Error(
        (error as { message?: string }).message ?? "Request failed",
      );
    }
  }

  async resetPassword(password: string): Promise<void> {
    const res = await fetch(`${BASE_URL}/v1/users/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({ password }),
      credentials: "include",
    });

    if (!res.ok) {
      if (res.status === 401) {
        throw new Error("401");
      }
      throw new Error("502");
    }
  }

  async logout(): Promise<void> {
    await fetch(`${BASE_URL}/v1/auth/logout`, {
      method: "POST",
      redirect: "manual",
      credentials: "include",
    });
  }

  async login(payload: LoginPayload): Promise<LoginResponse> {
    const res = await fetch(`${BASE_URL}/v1/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      credentials: "include",
    });

    if (!res.ok) {
      const error = await res.json().catch(() => ({}));
      throw new Error(
        (error as { message?: string }).message ?? "Login failed",
      );
    }

    return res.json();
  }
}

export const authProvider = new AuthProvider();
